import { EMPTY, fromEvent, interval, merge, of, type Observable } from 'rxjs';
import { distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';

/** Shared interval for notifications unread-count and list polling. */
export const NOTIFICATIONS_POLL_INTERVAL_MS = 30000;

/**
 * Emits once immediately when the document becomes visible, then every `periodMs` while it stays visible.
 * Pauses when the tab is hidden or the window is minimized; resumes with an immediate tick on return.
 */
export function pollTicksWhileDocumentVisible(periodMs: number): Observable<number> {
  return merge(of(undefined), fromEvent(document, 'visibilitychange')).pipe(
    map(() => document.visibilityState === 'visible'),
    distinctUntilChanged(),
    switchMap((visible) => (visible ? interval(periodMs).pipe(startWith(0)) : EMPTY))
  );
}
